<template>
  <HeaderApp />
  <div
    :class="
      'mx-2 mt-14 mb-5 h-full bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 no-print ' +
      ($store.getters['isRtl']
        ? $store.state.navbar.isSidebarCollapsed
          ? ' md:mr-20 '
          : ' md:mr-60 '
        : $store.state.navbar.isSidebarCollapsed
        ? ' md:ml-20  '
        : ' md:ml-60  ')
    "
  >
    <!-- Header Section -->
    <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
      <h1 class="text-xl font-semibold text-gray-900 dark:text-white">
        {{ $t("add_supliers") }}
      </h1>
    </div>

    <div class="m-2 p-3 bg-white dark:bg-bgMeduimDark rounded-2xl no-print">
      <div class="">
        <form @submit="addSaleItem">
          <div class="grid gap-x-6 mb-6 md:grid-cols-2">
            <BaseInput
              v-model="su_name"
              :label="$t('suplier_name')"
              :placeholder="$t('suplier_name')"
              :rules="rules"
              :isError="checkRulesIsError(su_name, 'add', this.rules).isError"
              :errorMsg="checkRulesIsError(su_name, 'add', this.rules).errorMsg"
            />
            <BaseInput
              v-model="su_phone"
              :label="$t('phone_number')"
              :placeholder="$t('phone_number')"
              :rules="rules"
              :isError="checkRulesIsError(su_phone, 'add', this.rules).isError"
              :errorMsg="
                checkRulesIsError(su_phone, 'add', this.rules).errorMsg
              "
            /><BaseInput
              v-model="su_address"
              :label="$t('address')"
              :placeholder="$t('address')"
              :rules="rules"
              :isError="
                checkRulesIsError(su_address, 'add', this.rules).isError
              "
              :errorMsg="
                checkRulesIsError(su_address, 'add', this.rules).errorMsg
              "
            />
            <BaseInput
              v-model="su_email"
              :label="$t('gmail')"
              :placeholder="$t('gmail')"
              :rules="no_rule"
              :isError="
                checkRulesIsError(su_email, 'add', this.no_rule).isError
              "
              :errorMsg="
                checkRulesIsError(su_email, 'add', this.no_rule).errorMsg
              "
            />
            <DropdownInput
              v-model="ci_id"
              :label="$t('city_name')"
              :placeholder="$t('choose_city')"
              :rules="rules_dropdown"
              :items="convertToListIdValueCitys"
              :isError="
                checkRulesIsError(ci_id, 'add', this.rules_dropdown).isError
              "
              :errorMsg="
                checkRulesIsError(ci_id, 'add', this.rules_dropdown).errorMsg
              "
              linkDrop="/sale-city"
            />
            <FileInput
              v-model="su_image"
              :label="$t('suplier_photo')"
              :placeholder="$t('choose_suplier_photo')"
              accept="image/*"
              :show-preview="true"
              @change="onChange"
            />
            <TextAreaInput
              v-model="su_note"
              :label="$t('note')"
              :placeholder="$t('note')"
              :rules="no_rule"
              :isError="checkRulesIsError(su_note, 'add', this.no_rule).isError"
              :errorMsg="
                checkRulesIsError(su_note, 'add', this.no_rule).errorMsg
              "
            />
          </div>

          <ButtonInput
            type="button"
            @click="addSaleItem"
            :label="$t('add')"
            :isLoading="isBtnLoading"
          />
        </form>
      </div>
    </div>
  </div>
  <div class="w-full" id="printDev">
    <InvoiceHeader invoice_type="supliers_list" v-if="isHide == true" />
    <div
      :class="
        ' mx-2 mt-14 mb-5 p-3 h-full bg-slate-100 dark:bg-bgFullDark rounded-2xl ' +
        (isHide == true
          ? '  '
          : $store.getters['isRtl']
          ? ' md:mr-60 '
          : ' md:ml-60  ')
      "
    >
      <div
        class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 my-6 gap-x-4 gap-y-2"
      >
        <div>
          <ReportComponent
            :labelDolar="formatNumber(totalOwedUsd)"
            :labelDinar="formatNumber(totalOwedIqd)"
            :labelTitle="$t('total_debts_on_me_supliers')"
            :classColor="isDark ? 'from-red-500' : 'from-red-50 to-red-100'"
          />
        </div>
        <div>
          <ReportComponent
            :labelDolar="formatNumber(totalSupliersUsdDebt)"
            :labelDinar="formatNumber(totalSupliersIqdDebt)"
            :labelTitle="$t('total_debts_on_supliers')"
            :classColor="isDark ? 'from-blue-500' : 'from-blue-50 to-blue-100'"
          />
        </div>
      </div>
      <div class="my-2 py-3 bg-white dark:bg-bgMeduimDark rounded-2xl">
        <div class="relative overflow-x-auto mt-4 mb-6">
          <div class="flex items-center justify-between pb-4 mx-5 no-print">
            <div class="flex items-center space-x-4">
              <BaseInput
                v-model="searchQuery"
                :placeholder="$t('search')"
                @input="handleSearchInput"
              >
                <template #prefix>
                  <i class="fa-solid fa-search text-gray-400 dark:text-gray-500"></i>
                </template>
              </BaseInput>
              <button
                class="mx-2 my_font bg-primaryColor hover:bg-blue-700 text-white font-bold py-1 px-4 rounded no-print"
                @click="printReportFunc"
                id="button_print"
                v-if="$store.getters['checkPrintAccess']"
              >
                {{ $t("print") }}
              </button>
            </div>
            
            <!-- Column Selection -->
            <div class="flex items-center space-x-4">
              <CustomMultiSelect
                v-model="selectedHeaders"
                :options="headers"
                track-by="value"
                label="text"
                :placeholder="$t('columns')"
                :header-text="$t('which_columns_to_display')"
                @update:modelValue="printCall"
              />
              <div class="w-0.5"></div>
              <button
                @click="resetToDefaultHeaders"
                class="group inline-flex items-center justify-center w-10 h-10 bg-gradient-to-br  text-blue-600 dark:text-blue-400 rounded-xl border border-blue-200 dark:border-gray-600 hover:from-blue-100 hover:to-indigo-200 dark:hover:from-gray-600 dark:hover:to-gray-700 hover:shadow-lg hover:shadow-blue-200/50 dark:hover:shadow-gray-900/50 hover:scale-105 active:scale-95 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 backdrop-blur-sm"
                :title="$t('reset_to_default')"
              >
                <i class="fa fa-refresh text-sm group-hover:rotate-180 transition-transform duration-500"></i>
              </button>
            </div>
          </div>
          <!--in ltr change (text-right to text-left)-->

          <EasyDataTable
            v-model:server-options="serverOptions"
            :headers="showHeaders"
            :items="items"
            :server-items-length="serverItemsLength"
            :loading="isLoadingData"
            :alternating="false"
            :buttons-pagination="true"
            :body-text-direction="$store.getters['isRtl'] ? 'right' : 'left'"
            :hide-footer="isHide"
            :rows-items="[25, 50, 100, serverItemsLength]"
            rows-per-page="10"
            :table-class-name="isDark ? 'modern-dark-table mx-6' : 'mx-6'"
          >
            <template #default="{ column, sortDirection }">
              <div :class="`flex items-center space-x-2 ${$store.getters['isRtl'] ? 'justify-end' : 'justify-start'}`">
                <span class="font-semibold text-gray-700 dark:text-gray-300">{{ column.label }}</span>
                <span v-if="column.sortable" class="text-gray-400">
                  <i
                    v-if="sortDirection === 'asc'"
                    class="fa-solid fa-arrow-up text-blue-500"
                  ></i>
                  <i
                    v-else-if="sortDirection === 'desc'"
                    class="fa-solid fa-arrow-down text-blue-500"
                  ></i>
                  <i v-else class="fa-solid fa-arrows-up-down text-gray-400"></i>
                </span>
              </div>
            </template>
            <template #item-actions="item">
              <button
                class="mx-1 my-1"
                @click="showModal(item)"
                v-if="
                  $store.getters['checkUserAccess']({
                    id: '30',
                    action: 'edit',
                  })
                "
              >
                <i
                  class="fa-solid fa-pen text-center p-1 w-7 h-7 text-sm bg-blue-200 dark:bg-blue-300 rounded-md text-blue-500 mx-auto"
                >
                  {{ item.text }}
                </i>
              </button>
              <button
                class="mx-1 my-1"
                @click="deleteItem(item.su_id)"
                v-if="
                  $store.getters['checkUserAccess']({
                    id: '30',
                    action: 'delete',
                  })
                "
              >
                <i
                  class="fa-solid fa-trash text-center p-1 w-7 h-7 text-sm bg-red-200 dark:bg-red-300 rounded-md text-red-500 mx-auto"
                ></i>
              </button>
              <button
                v-if="
                  $store.getters['checkUserAccess']({
                    id: '30',
                    action: 'view',
                  })
                "
                class="mx-1 my-1"
                @click="generateLink(item.su_id)"
              >
                <i
                  class="fa-solid fa-link text-center p-1 w-7 h-7 text-sm bg-blue-200 dark:bg-blue-300 rounded-md text-blue-500 mx-auto"
                ></i>
              </button>
              <a
                class="mx-1"
                :href="'suplier-account/' + item.su_id"
                v-if="
                  $store.getters['checkUserAccess']({
                    id: '30',
                    action: 'detail',
                  })
                "
                target="_blank"
              >
                <i
                  class="m-1 fa-solid fa-eye text-center p-1 w-7 h-7 text-sm bg-green-200 dark:bg-blue-300 rounded-md text-green-500 mx-auto"
                >
                  {{ item.text }}
                </i>
              </a>
            </template>
            <template #loading>
              <div class="flex items-center justify-center py-8">
                <img
                  src="../../assets/loading.webp"
                  class="w-16 h-16 animate-pulse"
                  alt="Loading..."
                />
              </div>
            </template>
            <template #item-total_iqd="item">
              <span
                :class="item.total_iqd > 0 ? 'text-red-500' : 'text-green-500'"
              >
                {{ formatNumber(item.total_iqd) }} {{ $t("dinar") }}
              </span>
            </template>
            <template #item-su_image="item">
              <img
                :src="file_url + item.su_image"
                class="inline-flex items-center justify-center text-white transition-all duration-200 ease-in-out text-size-sm h-16 w-16 rounded-xl"
                v-if="item.su_image"
                @click="openModal(file_url + item.su_image)"
              />
              <span v-if="item.su_image == '' || item.su_image == null">
                <i class="fa-solid fa-image text-primaryColor"></i>
              </span>
            </template>
            <template #item-total_usd="item">
              <span
                :class="item.total_usd > 0 ? 'text-red-500' : 'text-green-500'"
              >
                {{ formatNumber(item.total_usd) }} $
              </span>
            </template>
            <template #item-total_discount_iqd="item">
              <span
                v-if="parseFloat(item.total_discount_iqd || 0) > 0"
                class="text-green-600 font-semibold"
                :title="$t('total_debt_discount_gain')"
              >
                {{ formatNumber(item.total_discount_iqd) }} {{ $t("dinar") }}
              </span>
              <span v-else class="text-gray-400">-</span>
            </template>
            <template #item-total_discount_usd="item">
              <span
                v-if="parseFloat(item.total_discount_usd || 0) > 0"
                class="text-green-600 font-semibold"
                :title="$t('total_debt_discount_gain')"
              >
                {{ formatNumber(item.total_discount_usd) }} $
              </span>
              <span v-else class="text-gray-400">-</span>
            </template>
            <template #item-su_phone="item">
              <span
                v-if="item.su_phone == null || item.su_phone == ''"
                class="text-lg font-bold"
              >
                __
              </span>
              <a
                v-else
                :href="'tel:' + item.su_phone"
                class="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 hover:underline cursor-pointer transition-colors duration-200"
                :title="$t('click_to_call')"
              >
                <i class="fa-solid fa-phone mr-1"></i>
                {{ item.su_phone }}
              </a>
            </template>
            <template #item-su_email="item">
              <span
                v-if="item.su_email == null || item.su_email == ''"
                class="text-lg font-bold"
              >
                __
              </span>
              <span v-else>
                {{ item.su_email }}
              </span>
            </template>
            <template #item-su_note="item">
              <span
                v-if="item.su_note == null || item.su_note == ''"
                class="text-lg font-bold"
              >
                __
              </span>
              <span v-else>
                {{ item.su_note }}
              </span>
            </template>
            <template #item-created_at="item">
              {{ formatDate(item.created_at) }}
            </template>
            <template #item-updated_at="item">
              {{ formatDate(item.updated_at) }} </template
            ><template #empty-message>
              <span class="text-textBlack1 dark:text-white">
                {{ $t("no_data_found") }}
              </span>
            </template>
            <template
              #pagination="{
                prevPage,
                nextPage,
                isFirstPage,
                isLastPage,
                currentPaginationNumber,
                maxPaginationNumber,
              }"
            >
              <button :disabled="isFirstPage" @click="goToPage(1)">
                <i
                  :class="
                    'fa-sharp fa-solid ' +
                    ($store.getters['isRtl']
                      ? ' fa-angle-double-right'
                      : ' fa-angle-double-left')
                  "
                ></i>
              </button>
              <div class="w-5"></div>
              <button :disabled="isFirstPage" @click="prevPage">
                <i
                  :class="
                    'fa-sharp fa-solid ' +
                    ($store.getters['isRtl']
                      ? ' fa-angle-right'
                      : ' fa-angle-left ')
                  "
                ></i>
              </button>
              <div class="w-5"></div>
              <button
                v-for="page in getVisiblePages(
                  currentPaginationNumber,
                  maxPaginationNumber
                )"
                :key="page"
                @click="goToPage(page)"
                :class="getPageButtonClasses(page, currentPaginationNumber)"
              >
                {{ page }}
              </button>

              <div class="w-5"></div>
              <button :disabled="isLastPage" @click="nextPage">
                <i
                  :class="
                    'fa-sharp fa-solid ' +
                    ($store.getters['isRtl']
                      ? ' fa-angle-left'
                      : ' fa-angle-right')
                  "
                ></i>
              </button>
              <div class="w-5"></div>
              <button
                :disabled="isLastPage"
                @click="goToPage(maxPaginationNumber)"
              >
                <i
                  :class="
                    'fa-sharp fa-solid ' +
                    ($store.getters['isRtl']
                      ? ' fa-angle-double-left'
                      : ' fa-angle-double-right')
                  "
                ></i>
              </button> </template
          ></EasyDataTable>
        </div>
      </div>
    </div>
  </div>

  <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
  <ResultDialog ref="ResultDialog"></ResultDialog>
  <edit-modal ref="editModal">
    <div class="items-center">
      <form @submit="editItem">
        <BaseInput
          v-model="current.su_name"
          :label="$t('suplier_name')"
          :placeholder="$t('suplier_name')"
          :rules="rules"
          :isError="
            checkRulesIsError(current.su_name, 'edit', this.rules).isError
          "
          :errorMsg="
            checkRulesIsError(current.su_name, 'edit', this.rules).errorMsg
          "
        />

        <BaseInput
          v-model="current.su_phone"
          :label="$t('phone_number')"
          :placeholder="$t('phone_number')"
          :rules="rules"
          :isError="
            checkRulesIsError(current.su_phone, 'edit', this.rules).isError
          "
          :errorMsg="
            checkRulesIsError(current.su_phone, 'edit', this.rules).errorMsg
          "
        /><BaseInput
          v-model="current.su_address"
          :label="$t('address')"
          :placeholder="$t('address')"
          :rules="rules"
          :isError="
            checkRulesIsError(current.su_address, 'edit', this.rules).isError
          "
          :errorMsg="
            checkRulesIsError(current.su_address, 'edit', this.rules).errorMsg
          "
        />
        <BaseInput
          v-model="current.su_email"
          :label="$t('gmail')"
          :placeholder="$t('gmail')"
          :rules="no_rule"
          :isError="
            checkRulesIsError(current.su_email, 'edit', this.no_rule).isError
          "
          :errorMsg="
            checkRulesIsError(current.su_email, 'edit', this.no_rule).errorMsg
          "
        />
        <DropdownInput
          v-model="current.ci_id"
          :label="$t('city_name')"
          :placeholder="$t('choose_city')"
          :rules="rules_dropdown"
          :items="convertToListIdValueCitys"
          :isError="
            checkRulesIsError(current.ci_id, 'edit', this.rules_dropdown)
              .isError
          "
          :errorMsg="
            checkRulesIsError(current.ci_id, 'edit', this.rules_dropdown)
              .errorMsg
          "
        />
        <FileInput
          v-model="su_image"
          :label="$t('suplier_photo')"
          :placeholder="$t('choose_suplier_photo')"
          accept="image/*"
          :show-preview="true"
          @change="onChange"
        />
        <TextAreaInput
          v-model="current.su_note"
          :label="$t('note')"
          :placeholder="$t('note')"
          :rules="no_rule"
          :isError="
            checkRulesIsError(current.su_note, 'edit', this.no_rule).isError
          "
          :errorMsg="
            checkRulesIsError(current.su_note, 'edit', this.no_rule).errorMsg
          "
        />
        <center>
          <ButtonInput
            type="button"
            @click="editItem"
            :label="$t('edit')"
            :isLoading="isBtnEditLoading"
          />
        </center>
      </form>
    </div> </edit-modal
  ><image-modal ref="imageModal" />
</template>
<script>
//import hearder-app
import HeaderApp from "../../components/Navbar/header-app.vue";
import BaseInput from "../../components/Inputs/BaseInput.vue";
import TextAreaInput from "../../components/Inputs/TextAreaInput.vue";
import ButtonInput from "../../components/Inputs/ButtonInput.vue";
import FileInput from "../../components/Inputs/FileInput.vue";
import { formatDate } from "../../utils/functions";
import ConfirmDialogue from "../../components/Modals/ConfirmDialogue.vue";
import ResultDialog from "../../components/Modals/ResultDialog.vue";
import EditModal from "../../components/Modals/EditModal.vue";
import DropdownInput from "../../components/Inputs/DropdownInput.vue";
import { formatNumber } from "../../utils/functions";
import { FILE_URL } from "../../constants/config";
import ImageModal from "../../components/Modals/ImageModal2.vue";
import InvoiceHeader from "../../components/Navbar/InvoiceHeader.vue";
import ReportComponent from "../../components/Report/ReportComponent.vue";
import CustomMultiSelect from "../../components/Inputs/CustomMultiSelect.vue";

export default {
  name: "ADD_SALE_TYPE",
  components: {
    HeaderApp,
    BaseInput,
    ButtonInput,
    FileInput,
    CustomMultiSelect,
    ConfirmDialogue,
    ResultDialog,
    EditModal,
    TextAreaInput,
    DropdownInput,
    ImageModal,
    InvoiceHeader,
    ReportComponent,
  },
  data() {
    return {
      firstName: "",
      searchQuery: "",
      rules: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_fill_this_field");
        },
      ],
      no_rule: [],
      su_name: "",
      su_note: "",
      su_phone: "",
      su_address: "",
      su_email: "",
      inputType: "text",
      isSubmited: false,
      isSubmitedEdit: false,
      current: {},
      ci_id: "",
      rules_dropdown: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_choose_an_option");
        },
      ],
      file_url: FILE_URL,
      su_image: "",
      serverItemsLength: 0,
      serverOptions: {
        page: 1,
        rowsPerPage: 12,
      },
      loading: false,
      items: [],
      isHide: false,
      selectedHeaders: [],
      columnsControl: false,
      totalSupliersIqdDebt: 0,
      totalSupliersUsdDebt: 0,
      totalOwedIqd: 0,
      totalOwedUsd: 0,
    };
  },
  created() {
    this.$store.dispatch("sale_city/getCitys");
    this.getTotal();
  },
  mounted() {
    // First load when the component is mounted
    if (
      this.$store.getters["checkUserAccess"]({
        id: "30",
        action: "view",
      })
    ) {
      this.loadFromServer();
    }
    this.loadSelectedHeaders();
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    getResultDialog(newValue, oldValue) {
      if (newValue) {
        this.$refs.ResultDialog.show({
          message: this.$store.state.suplier.resultMsg,
          okButton: this.$t("done"),
          isSuccess: this.$store.state.suplier.isSuccess,
        });

        // Reset the deleteSuccess state after showing the dialog
        this.$store.commit("suplier/SET_DELETE_SUCCESS", false);
      }
    },
    serverOptions: {
      handler() {
        this.loadFromServer();
      },
      deep: true,
    },
    headers: {
      handler() {
        // When headers change, update selectedHeaders to match
        if (this.headers && this.headers.length > 0) {
          this.loadSelectedHeaders();
        }
      },
      immediate: true,
    },
  },

  computed: {
    getResultDialog() {
      return this.$store.state.suplier.isShowResultDialog;
    },

    filterItems() {
      return this.$store.getters["suplier/filterItems"];
    },
    isDark() {
      return this.$store.state.theme == "dark";
    },
    isLoadingData() {
      return this.$store.state.suplier.isLoadingData;
    },
    isBtnLoading() {
      return this.$store.state.suplier.isBtnLoading;
    },
    isBtnEditLoading() {
      return this.$store.state.suplier.isBtnEditLoading;
    },
    headers() {
      var listHeader = [
        { text: "#", value: "su_id", sortable: true },
        { text: this.$t("suplier_name"), value: "su_name", sortable: true },

        { text: this.$t("phone_number"), value: "su_phone", sortable: true },

        {
          text: this.$t("debt_result_dinar"),
          value: "total_iqd",
          sortable: true,
        },
        {
          text: this.$t("debt_result_dollar"),
          value: "total_usd",
          sortable: true,
        },
        {
          text: this.$t("total_discount_received_dinar"),
          value: "total_discount_iqd",
          sortable: false,
        },
        {
          text: this.$t("total_discount_received_dollar"),
          value: "total_discount_usd",
          sortable: false,
        },
        { text: this.$t("photo"), value: "su_image", sortable: false },
        { text: this.$t("city"), value: "city.ci_name", sortable: true },
        { text: this.$t("address"), value: "su_address", sortable: true },
        { text: this.$t("gmail"), value: "su_email", sortable: true },
        { text: this.$t("note"), value: "su_note", sortable: true },
        { text: this.$t("admin"), value: "users.name", sortable: true },
        { text: this.$t("created_at"), value: "created_at", sortable: true }, {
          text: this.$t("last_transaction"),
          value: "updated_at",
          sortable: true,
        },
        { text: this.$t("actions"), value: "actions", sortable: false },
      ];
      //remove actions from header if isHide is true
      if (this.isHide == true) {
        listHeader.pop();
      }

      return listHeader;
    },
    showHeaders() {
      var temp = [];
      //cretae a for check all selectedHeaders add to temp
      for (let i = 0; i < this.selectedHeaders.length; i++) {
        for (let j = 0; j < this.headers.length; j++) {
          if (this.selectedHeaders[i].text == this.headers[j].text) {
            temp.push(this.headers[j]);
          }
        }
      }
      //check if empty add all headers to temp
      if (temp.length == 0) {
        temp = this.headers;
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.selectedHeaders = temp;
      }

      if (temp.length == 0) {
        temp = this.headers;
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.selectedHeaders = temp;
      }

      return temp;
    },
    convertToListIdValueCitys() {
      var citys = this.$store.state.sale_city.citys;
      var list = [];
      for (const item of citys) {
        list.push({
          id: item.ci_id,
          value: item.ci_name,
        });
      }

      return list;
    },
  },

  methods: {
    handleSearchInput() {
      this.$store.commit('suplier/SET_SEARCH', this.searchQuery);
      this.loadFromServer();
      this.serverOptions.page = 1;
    },
    async generateLink(id) {
      var payload = {
        id: id,
        path: "/debt",
        type: "supplier",
      };
      await this.$store.dispatch("suplier/generateLink", payload);
    },
    async getTotal() {
      var res = this.$store.dispatch("suplier/getTotalDebts");
      res.then((response) => {
        this.totalSupliersIqdDebt = response.totalSupliersIqdDebt;
        this.totalSupliersUsdDebt = response.totalSupliersUsdDebt;
        this.totalOwedIqd = response.totalOwedIqd;
        this.totalOwedUsd = response.totalOwedUsd;
      });
    },
    printReportFunc() {
      this.isHide = true;
      //wait 1 second
      setTimeout(() => {
        var printContents = document.getElementById("printDev").innerHTML;

        // Replace the body's innerHTML with the print contents
        document.body.innerHTML = printContents;
        var isRtl = this.$store.getters["isRtl"];
        // Set direction based on the parameter
        if (isRtl) {
          document.body.style.direction = "rtl";
        } else {
          document.body.style.direction = "ltr";
        }

        // Print the content
        window.print(); // Adjust the timeout as needed
        //reload page
      }, 100);
      //print element id invoice_print
    },
    getVisiblePages(currentPage, totalPages) {
      const numVisibleButtons = 3; // Adjust this number based on your design preference
      const pages = [];

      // Display pages 1 to numVisibleButtons (e.g., 1, 2, 3)
      if (currentPage <= Math.floor(numVisibleButtons / 2) + 1) {
        for (let i = 1; i <= Math.min(totalPages, numVisibleButtons); i++) {
          pages.push(i);
        }
      }
      // Display pages around the current page (e.g., 1, ..., 10, ..., 20)
      else {
        const startPage = Math.max(
          1,
          currentPage - Math.floor(numVisibleButtons / 2)
        );
        const endPage = Math.min(totalPages, startPage + numVisibleButtons - 1);

        for (let i = startPage; i <= endPage; i++) {
          pages.push(i);
        }
      }

      return pages;
    },

    // Function to get Tailwind CSS classes for each page button
    getPageButtonClasses(page, currentPage) {
      return {
        "bg-blue-500 text-white": page === currentPage,
        "bg-gray-300 text-gray-700 hover:bg-gray-400": page !== currentPage,
        "p-2 rounded-md mx-1": true, // Adjust padding and rounding based on your design
      };
    },

    goToPage(page) {
      // Implement your logic to update the current page
      //update page
      this.serverOptions.page = page;
      this.loadFromServer();
    },
    async loadFromServer() {
      this.loading = true;

      var tempObj = { ...this.serverOptions };
      //add new field to object search
      tempObj.search = this.$store.state.suplier.search;

      const res = await this.$store.dispatch("suplier/getItems", tempObj);

      this.items = res.data.data;
      this.serverItemsLength = res.data.total;
      this.loading = false;
    },
    openModal(image) {
      this.$refs.imageModal.show(image);
    },
    onChange(e) {
      this.su_image = e.target.files[0];
      e.target.value = "";
    },
    formatNumber(number) {
      return formatNumber(number);
    },
    formatDate(date) {
      return formatDate(date);
    },
    getData() {
      this.$store.dispatch("suplier/getItems");
    },
    async addSaleItem() {
      //check form validation
      if (this.$store.state.suplier.isBtnLoading) return;

      this.isSubmited = true;
      if (
        this.checkRulesIsError(this.su_name, "add", this.rules).isError ||
        this.checkRulesIsError(this.su_phone, "add", this.rules).isError ||
        this.checkRulesIsError(this.su_address, "add", this.rules).isError ||
        this.checkRulesIsError(this.ci_id, "add", this.rules_dropdown).isError
      ) {
        return;
      }
      this.$store.state.suplier.isBtnLoading = true;
      var res = await this.$store.dispatch("suplier/addNewItem", {
        su_name: this.su_name,
        su_note: this.su_note,
        su_phone: this.su_phone,
        su_address: this.su_address,
        su_email: this.su_email,
        ci_id: this.ci_id,
        su_image: this.su_image,
      });
      if (res.status == 200) {
        this.su_name = "";
        this.su_note = "";
        this.su_phone = "";
        this.su_address = "";
        this.su_email = "";
        this.isSubmited = false;
        this.$store.state.suplier.isBtnLoading = false;
        this.su_image = "";
        this.loadFromServer();
      }
    },
    checkRulesIsError(value, type, rules) {
      var isError = false;
      var errorMsg = "";
      if (type == "add") {
        if (this.isSubmited == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }
      if (type == "edit") {
        if (this.isSubmitedEdit == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }

      for (const rule of rules) {
        if (rule(value) !== true) {
          isError = true;
          errorMsg = rule(value);
          // Stop the loop
          break;
        } else {
          isError = false;
          errorMsg = "";
        }
      }

      return {
        isError: isError,
        errorMsg: errorMsg,
      };
    },
    async deleteItem(id) {
      const ok = await this.$refs.confirmDialogue.show({
        message: this.$t("are_you_sure_remove_this_item") + id,
        okButton: this.$t("delete"),
      });
      if (ok) {
        this.$store.commit("suplier/REMOVE_ITEM", id);
        await this.$store.dispatch("suplier/deleteItem", id);
        this.loadFromServer();
      }
    },
    //edit
    async showModal(item) {
      this.current = item;

      this.current.ci_id = this.current.ci_id.toString();
      await this.$refs.editModal.show();
    },
    async editItem(e) {
      e.preventDefault();
      this.isSubmitedEdit = true;
      if (
        this.checkRulesIsError(this.current.su_name, "edit", this.rules)
          .isError ||
        this.checkRulesIsError(this.current.su_phone, "edit", this.rules)
          .isError ||
        this.checkRulesIsError(this.current.su_address, "edit", this.rules)
          .isError ||
        this.checkRulesIsError(this.current.ci_id, "edit", this.rules_dropdown)
          .isError
      ) {
        return;
      }
      this.$store.state.suplier.isBtnEditLoading = true;
      var res = await this.$store.dispatch("suplier/editItem", {
        su_id: this.current.su_id,
        su_name: this.current.su_name,
        su_note: this.current.su_note,
        su_phone: this.current.su_phone,
        su_address: this.current.su_address,
        su_email: this.current.su_email,
        ci_id: this.current.ci_id,
        su_image: this.su_image,
      });

      this.isSubmitedEdit = false;
      this.$store.state.suplier.isBtnEditLoading = false;
      this.loadFromServer();
      this.su_image = "";
      if (res.status == 200) {
        this.$refs.editModal.hide();
      }
    },
    loadSelectedHeaders() {
      // Load selected headers from localStorage
      const savedHeaders = localStorage.getItem("suplierSelectedHeaders");
      if (savedHeaders) {
        try {
          const parsedHeaders = JSON.parse(savedHeaders);
          // Filter to only include headers that exist in current headers list
          this.selectedHeaders = this.headers.filter((header) =>
            parsedHeaders.some((saved) => saved.value === header.value)
          );
        } catch (error) {
          console.error("Error loading saved headers:", error);
          this.selectedHeaders = [...this.headers];
        }
      } else {
        // If no saved headers, select all by default
        this.selectedHeaders = [...this.headers];
      }
    },
    saveSelectedHeaders() {
      // Save selected headers to localStorage
      try {
        localStorage.setItem(
          "suplierSelectedHeaders",
          JSON.stringify(this.selectedHeaders)
        );
      } catch (error) {
        console.error("Error saving headers:", error);
      }
    },
    printCall(selectedHeaders) {
      // Handle column selection changes
      if (selectedHeaders && Array.isArray(selectedHeaders)) {
        this.selectedHeaders = selectedHeaders;
        this.saveSelectedHeaders();
      }
    },
    resetToDefaultHeaders() {
      // Reset to select all headers
      this.selectedHeaders = [...this.headers];
      this.saveSelectedHeaders();
    },
  },
};
</script>
